import Breadcrumbs from './breadcrumbs'
import CityBreadcrumbs from './city-breadcrumbs'

export { Breadcrumbs, CityBreadcrumbs }

export default Breadcrumbs
